import { render, staticRenderFns } from "./JayMessage.vue?vue&type=template&id=3015c0e7&scoped=true"
import script from "./JayMessage.vue?vue&type=script&lang=js"
export * from "./JayMessage.vue?vue&type=script&lang=js"
import style0 from "./JayMessage.vue?vue&type=style&index=0&id=3015c0e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015c0e7",
  null
  
)

export default component.exports